module.exports = __webpack_public_path__ + "img/website-ode.cba95fe6.png";